import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class AnnouncementService extends CrudService {
  constructor() {
    super(API_RESOURCE.ANNOUNCEMENT)
  }

  fetchAnnouncementByType = async (type) => {
    const response = await axios.get(`${this.resource}/type/${type}`)
    return response.data
  }
}

export default AnnouncementService
